<template>
    <div class="navMenu fillcontain">
        <el-row style="height:100%;">
            <el-col :span="4" style="height:100%;">
                <div class="navMenu_header">
                    <img src="http://landlord.jrechina.com/images/logo.png">
                </div>
                <el-menu
                    style="height:100%;"
                    class="el-menu-vertical-demo"
                    background-color="#545c64"
                    :default-active="defaultActive"
                    text-color="#fff"
                    active-text-color="#ffd04b"
                    router>
                    <el-menu-item index="/controlPanel">
                        <i class="iconfont icon-yibiao" style="font-size: 25px;"></i>
                        <span slot="title">控制面板</span>
                    </el-menu-item>
                    <el-menu-item index="/houseResource/houseResourceMessage">
                        <i class="iconfont icon-chanpin" style="font-size: 25px;"></i>
                        <span slot="title">房源管理</span>
                    </el-menu-item>
                    <el-menu-item index="/publishHouse">
                        <i class="iconfont icon-xinjian" style="font-size: 25px;"></i>
                        <span slot="title">新建房源</span>
                    </el-menu-item>
                    <el-menu-item index="/message">
                        <i class="iconfont icon-xiaoxi" style="font-size: 25px;"></i>
                        <span slot="title">待处理及通知</span>
                    </el-menu-item>
                    <el-menu-item index="/filesManage">
                        <i class="iconfont icon-wenjian" style="font-size: 25px;"></i>
                        <span slot="title">文件管理</span>
                    </el-menu-item>
                </el-menu>
            </el-col>
            <el-col :span="20" style="overflow:auto;height:100%">
                <div class="content_header">
                    <Tips></Tips>
                </div>
                
                <div>
                    <router-view></router-view>
                </div>
                
            </el-col>
        </el-row>
       
    </div>
</template>

<script>
import Tips from '@/components/tips/tips.vue'
export default {
    computed: {
        defaultActive: function(){
            return this.$route.path.replace('/', '');
        }
    },
    components:{
        Tips
    },
    data(){
        return {
            myname: 'my is'
        }
    },
    methods: {
    //   handleOpen(key, keyPath) {
    //     console.log(key, keyPath);
    //   },
    //   handleClose(key, keyPath) {
    //     console.log(key, keyPath);
    //   }
    }
  }
</script>

<style>
.navMenu{

}
.content_header{
    height:70px;
    border-bottom:1px solid #efefef;
    line-height: 70px;
}
.fillcontain {
  height: 100%;
  width: 100%;
  position: fixed;
  top:0;
  bottom:0;
  margin:auto;
}
.navMenu_header{
    height: 70px;
    background: #278bdd;
    line-height: 90px;
    border-right:1px solid #fff;
    text-align: center;
}
.navMenu .iconfont{
    
}
</style>



// WEBPACK FOOTER //
// src/components/NavMenu.vue